import React from "react";
import "./Signup.css";
import Image from "../../images/svg2.svg";
import { useTranslation } from "react-i18next";
import { motion } from "framer-motion";
import { animationVariants } from "../../constants/animationVariants";

const FormSuccess = () => {
  const { t } = useTranslation();

  return (
    <motion.div
      className="form-content-right"
      initial="initial"
      whileInView="animate"
      viewport={{ once: true, amount: 0.2 }}
    >
      <motion.h1 className="form-success" variants={animationVariants.fadeUp}>
        {t("form.success")}!!!
      </motion.h1>
      <img
        src={Image}
        alt="success"
        className="form-img-2"
      />
    </motion.div>
  );
};

export default FormSuccess;
